module.exports = __webpack_public_path__ + "img/fashion_51.8dddcb4d.jpg";